import React  from "react";
import { FormControl } from "react-bootstrap";
import classNames from "classnames";

export const ContactInput = ({
    value,
    error,
    loadingContacts,
    onChange,
  }: {
    value: string;
    error: string;
    loadingContacts: boolean;
    onChange: (value: string) => void;
  }) => {
    if (loadingContacts) {
      return <div className="contact-input animate-pulse" />;
    }
  
    return (
      <>
        <FormControl
          type="text"
          value={value}
          maxLength={70}
          className={classNames(
            "contact-input",
            error && "invalid-control"
          )}
          onChange={(e) => onChange(e.target.value)}
        />
  
        {error && (
          <p className="text-danger validation-label">
            {error}
          </p>
        )}
      </>
    );
  };